<template>

    <div class="layout__padding-clear layout__width-80">

        <div class="text__align-center text__colour-white layout__margin__bottom-25px">
            <div class="layout__padding-clear layout__width-70 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                <h2 class="text__colour-teal">My Invoices</h2>
                <div class="layout__padding-20-0 text__size-18 text__colour-grey">View your previous monthly invoices or download a copy of the PDF using the link at the end of each row
                </div>
            </div>
        </div>

        <div class="layout__width-100 layout__position-left">
            <el-table :data="orders" :default-sort="{prop: 'code', order: 'descending'}" style="width: 100%;" class="layout__height-600px layout__scrolling__right layout__margin__bottom-30" v-loading="loading">
                <el-table-column type="index" width="100%">
                </el-table-column>
                <el-table-column prop="code" label="Invoice No" width="">
                </el-table-column>
                <el-table-column prop="billMonth" label="Bill Month" width="" :formatter="returnMonthName">
                </el-table-column>
                <el-table-column prop="billYear" label="Bill Year" width="" sortable>
                </el-table-column>
                <el-table-column prop="branch" label="Branch" width="">
                </el-table-column>
                <el-table-column prop="noJobs" label="No Jobs" width="">
                </el-table-column>
                <el-table-column prop="netTotal" label="Net Total" width="" :formatter="returnCurrency">
                </el-table-column>
                <el-table-column prop="vatTotal" label="Vat Total" width="" :formatter="returnCurrency">
                </el-table-column>
                <el-table-column prop="grossTotal" label="GrossTotal" width="" :formatter="returnCurrency">
                </el-table-column>
                <el-table-column label="Download" width="">
                    <template slot-scope="props">
                            <img class="layout__width-20px layout__position-center" v-if="isCurrentMonth(props)"
                                 v-on:click="downloadInvoice(props)" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">
                        <img class="layout__width-20px layout__position-center" v-else src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download-null.png">
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import AdminOrdersSearch from '../../components/search/AdminOrdersSearch.vue';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import Pagination from "../../components/Pagination";
    import moment from 'moment';
    import Router from '../../router';

    export default {
        name: "invoices",
        mixins: [axios, dataFormatter, csvDownloadHelper],
        components: {
            Pagination,
            AdminOrdersSearch,
        },
        props: {
            view: ''
        },
        data() {
            return {
                orders: [],
                loading: false,
                exportDate: new Date().toLocaleTimeString('en-GB') + '_orders.xls',
            }
        },
        created() {
            let invoices = ''

            if (JSON.parse(this.returnCookie("_role")).includes('Customer')) {
                invoices = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/invoiceSearchcustomers?myCustomerRef=` + JSON.parse(this.returnCookie("_customer")).ref + '&startDate=' + moment().subtract(1, "year").format("YYYY-MM-MM") + '&endDate=' + moment().format("YYYY-MM-MM")

            } else {
                invoices = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/invoiceSearchcustomers?startDate=` + moment().subtract(1, "year").format("YYYY-MM-MM") + '&endDate=' + moment().format("YYYY-MM-MM") + '&top=12'
            }

            console.log(invoices)

            Axios.get(invoices, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response.data.value)
                    this.orders = response.data.value

                    console.log(this.orders.length)

                    for (let i = 0; i < this.orders.length; i++) {
                        this.orders[i].created = this.orders[i].created.split("T")[0]
                    }
                    this.loading = false
                })
                .catch(error => {
                    this.loading = false
                    this.orders = []
                })
        },
        methods: {
            downloadInvoice(props) {
                const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Billing/GetInvoiceByCode/?invoiceCode=` + props.row.code + '&access_token=' + this.returnCookie('_token')
                this.downloadLink(event, url)
                event.stopPropagation();
            },
            isCurrentMonth(props) {
                if (moment().month() === props.row.orderMonth && moment().year() === props.row.month) {
                    return false;
                } else {
                    return true;
                }


            }
        }
    };
</script>